import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import store from "@/store";

import { maskCurrency, maskCurrencyToFloat } from "@/common/utils/mask";
import { toast } from "@/common/utils/toast";

import { planList, planCreate, planDelete } from "@/common/api/rest/plan/plan";

import type { PlanType, PlanPayloadType } from "@/common/types/plan/plan";

import { PanelTheme } from "@/common/themes";
import { FormPlan } from "@/components";
import {
	breadcrumbSimple,
	baseConfirm,
	baseModal,
	baseTable,
	svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, tm } = useI18n();
const router = useRouter();

const tableData = ref<PlanType[]>([]);
const payload = ref<PlanPayloadType | null>(null);

const selected = ref<PlanType | null>(null);

const limit = ref<number>(6);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalDel = ref(false);
const payloadValid = ref(false);
const loading = ref(false);

const tableHeader = computed(() => [
	{ key: "name", label: t("common.labels.name") },
	{ key: "status", label: t("common.labels.status") },
	{ key: "free", label: t("common.labels.free") },
]);

const breadcrumbList = computed(() => [
	{
		key: "register",
		label: t("common.labels.registrations"),
		url: "/register",
	},
	{
		key: "plans",
		label: t("common.labels.plans"),
		url: "/register/plan",
	},
]);

const statusOptions = computed(() => ({
	ACTIVE: t("common.labels.active"),
	INACTIVE: t("common.labels.inactive"),
}));

const currencies = computed(
	() => tm("enums.currencies") as Record<string, string>,
);

function fetchData() {
	loading.value = true;
	planList({
		page: page.value,
		limit: limit.value,
		search: search.value,
	})
		.then((response) => {
			const { success, data, message } = response;
			if (success) {
				tableData.value = data.list?.map((item: PlanType) => {
					// const newPrice = item.price ? item.price / 100 : 0;
					return {
						...item,
						// price: newPrice,
					};
				});
				pages.value = data.infos.pages;
				total.value = data.infos.total;
				searched.value = data.infos.count;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			loading.value = false;
		});
}

function changePage(value: number) {
	page.value = value;
	fetchData();
}

function searchItem(value: string) {
	search.value = value;

	fetchData();
}

function addItem() {
	showModalAdd.value = true;
}

function addItemCancel() {
	showModalAdd.value = false;
	payload.value = null;
}

function addItemConfirm() {
	if (!payload.value) return;

	store.commit("SET_LOADING", true);

	// const priceStr = payload.value.price.toString().replace(",", ".");
	// const priceCents = Math.round(parseFloat(priceStr) * 100);

	const newPayload = {
		...payload.value,
		// price: priceCents,
	};

	planCreate(newPayload)
		.then((response) => {
			const { success, data, message } = response;

			if (success) {
				editItem(data);
				toast({ message: message, type: "success" });
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function editItem(data: PlanType) {
	router.push(`/register/plan/${data.plan_id}/edit`);
}

function removeItem(data: PlanType) {
	selected.value = data;
	showModalDel.value = true;
}

function removeItemCancel() {
	showModalDel.value = false;
	selected.value = null;
}

function removeItemConfirm() {
	if (!selected.value) return;

	planDelete(selected.value.plan_id)
		.then((response) => {
			const { success, message } = response;

			fetchData();
			removeItemCancel();
			toast({ message: message, type: success ? "success" : "error" });
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function formatCurrency(value: number, currency: any) {
	const price = Number.parseFloat(value?.toString()).toFixed(2);
	return maskCurrency(price, currency);
}

onMounted(() => {
	fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_unref(breadcrumbSimple), {
          items: breadcrumbList.value,
          "show-home": true,
          "url-home": "/home",
          active: "plans"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(svgIcon), {
            icon: "plans",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("plan.labels.plans")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(baseTable), {
            header: tableHeader.value,
            data: tableData.value,
            limit: limit.value,
            page: page.value,
            pages: pages.value,
            total: total.value,
            searched: searched.value,
            loading: loading.value,
            options: true,
            del: true,
            edit: true,
            "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
            onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
            "onBtn:add": _cache[2] || (_cache[2] = ($event: any) => (addItem())),
            "onBtn:edit": _cache[3] || (_cache[3] = ($event: any) => (editItem($event))),
            "onBtn:del": _cache[4] || (_cache[4] = ($event: any) => (removeItem($event)))
          }, {
            status: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(statusOptions.value[data.status]), 1)
            ]),
            free: _withCtx(({ data }) => [
              (data.free)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.yes")), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.not")), 1)
                  ], 64))
            ]),
            currency: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(currencies.value[data.currency]), 1)
            ]),
            frequency: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.frequency) + " ", 1),
              (data.frequency > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.days")), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.day")), 1)
                  ], 64))
            ]),
            price: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(formatCurrency(data.price, data.currency)), 1)
            ]),
            _: 1
          }, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "loading"])
        ])
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: _unref(t)('plan.modals.titles.plan_add').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (addItemCancel())),
      onConfirm: _cache[8] || (_cache[8] = ($event: any) => (addItemConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(FormPlan), {
          data: selected.value,
          "onUpdate:data": _cache[5] || (_cache[5] = ($event: any) => (payload.value = $event)),
          onValidate: _cache[6] || (_cache[6] = ($event: any) => (payloadValid.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('plan.modals.titles.plan_remove').toUpperCase(),
      message: 
			_unref(t)('plan.modals.messages.plan_remove', {
				name: selected.value?.name?.toUpperCase(),
			})
		,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (removeItemCancel())),
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (removeItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})